import _ from 'lodash';
import config from 'config';

class GoogleRemarketing {
  constructor() {
    this.googleRemarketingInterval = null;
    this.pendingEvents = [];
  }

  default () {
    let googleRemarketingCustomParams = {
        ecomm_prodid: '1',
        ecomm_pagetype: 'other',
      },
      googleRemarketingPayload = this._remarketingPayload(config.Analytics.googleRetargetID, googleRemarketingCustomParams);

    window.dataLayer.push({ 'vsGoogleRemarketingPayload': googleRemarketingPayload });
  }

  vsSales(campaign) {
    if (!campaign.pixels.global.disable_vs_retargeting) {
      let googleRemarketingCustomParams = this._salesPayload(campaign),
        googleRemarketingPayload = this._remarketingPayload(config.Analytics.googleRetargetID, googleRemarketingCustomParams);

      window.dataLayer.push({ 'vsGoogleRemarketingPayload': googleRemarketingPayload });

      this._asyncEvent('vs-google-remarketing-sales-tracking');
    }
  }

  _globalPixelIsNotCampaignPixel(campaign) {
    return campaign.pixels.campaign.google.id !== campaign.pixels.global.google.id;
  }

  clientSales(campaign) {
    this._clientSalesHelper(campaign.pixels.campaign, campaign);

    if (this._globalPixelIsNotCampaignPixel(campaign)) {
      this._clientSalesHelper(campaign.pixels.global, campaign);
    }
  }

  _clientSalesHelper(pixels, campaign) {
    if (pixels.google.id) {
      let googleRemarketingCustomParams = this._salesPayload(campaign),
        googleRemarketingPayload = this._remarketingPayload(pixels.google.id, googleRemarketingCustomParams, true, pixels.google.label);

      window.dataLayer.push({ 'clientGoogleRemarketingPayload': undefined });
      window.dataLayer.push({ 'clientGoogleRemarketingPayload': googleRemarketingPayload });

      this._asyncEvent('client-google-remarketing-tracking')
    }
  }

  vsThankYou(order) {
    let googleRemarketingCustomParams = this._thankYouPayload(order),
      googleRemarketingPayload = this._remarketingPayload(config.Analytics.googleRetargetID, googleRemarketingCustomParams),
      thankYouRemarkertingPayload = {
        google_conversion_id: config.Analytics.googleRetargetID,
        google_conversion_language: 'en',
        google_conversion_format: '3',
        google_conversion_color: 'ffffff',
        google_conversion_label: 'gva2CLne_mEQvNehzQM',
        google_remarketing_only: false
      },
      thankYouRemarkertingPayload2 = {
        google_conversion_id: config.Analytics.googleAdwordsID,
        google_conversion_language: 'en',
        google_conversion_format: '3',
        google_conversion_color: 'ffffff',
        google_conversion_label: 'TEdcCP2zjGcQrrH5vQM',
        google_conversion_value: `${(order.price.sub_total - order.price.coupon_discount).toFixed(2)}`,
        google_conversion_currency: 'USD',
        google_remarketing_only: false
      };

    window.dataLayer.push({ 'vsGoogleRemarketingPayloadThankYou': thankYouRemarkertingPayload });
    window.dataLayer.push({ 'vsGoogleRemarketingPayloadThankYou2': thankYouRemarkertingPayload2 });
    window.dataLayer.push({ 'vsGoogleRemarketingPayload': googleRemarketingPayload });

    this._asyncEvent('vs-google-remarketing-thank-you-tracking')
  }

  clientThankYou(order) {
    this._clientThankYouHelper(order.campaign.pixels.campaign, order);

    if (this._globalPixelIsNotCampaignPixel(order.campaign)) {
      this._clientThankYouHelper(order.campaign.pixels.global, order);
    }
  }

  _clientThankYouHelper(pixels, order) {
    if (pixels.google.id) {
      let googleRemarketingCustomParams = this._salesPayload(order.campaign),
        googleRemarketingPayload = this._remarketingPayload(pixels.google.id, googleRemarketingCustomParams, true, pixels.google.label),
        googleRemarketingThankYouCustomParams = this._thankYouPayload(order),
        googleRemarketingThankYouPayload = this._remarketingPayload(pixels.google.id, googleRemarketingThankYouCustomParams, false, pixels.google.label);

      window.dataLayer.push({ 'clientGoogleRemarketingPayload': undefined });
      window.dataLayer.push({ 'clientGoogleRemarketingThankYouPayload': undefined });
      window.dataLayer.push({ 'clientGoogleRemarketingPayload': googleRemarketingPayload });
      window.dataLayer.push({ 'clientGoogleRemarketingThankYouPayload': googleRemarketingThankYouPayload });

      this._asyncEvent('client-google-remarketing-tracking');
      this._asyncEvent('client-google-remarketing-thank-you-tracking');
    }
  }

  register() {
    window.dataLayer.push({
      'vsGoogleRemarketingRegisterPayload': {
        google_conversion_id: config.Analytics.googleRetargetID,
        google_conversion_label: "8wYGCPD75WYQvNehzQM",
        google_conversion_format: "3",
        google_remarketing_only: false
      }
    });
    window.dataLayer.push({
      'vsGoogleRemarketingRegister2Payload': {
        google_conversion_id: config.Analytics.googleAdwordsID,
        google_conversion_label: "ivwfCODPoGcQrrH5vQM",
        google_conversion_format: "3",
        google_remarketing_only: false
      }
    });
  }

  _remarketingPayload(id, customParams, remarketingOnly = true, conversionLabel) {
    let payload = {
      google_conversion_id: id,
      google_custom_params: customParams,
      google_remarketing_only: remarketingOnly
    };
    if (conversionLabel) payload.google_conversion_label = conversionLabel;
    return payload;
  }

  _salesPayload(campaign) {
    return {
      ecomm_prodid: campaign.id || '',
      ecomm_pagetype: 'product',
    }
  }

  _thankYouPayload(order) {
    return {
      ecomm_prodid: order.campaign_id || '',
      ecomm_pagetype: 'purchase',
      ecomm_totalvalue: `${(order.price.sub_total - order.price.coupon_discount).toFixed(2)}`,
    }
  }

  _asyncEvent(event) {
    if (window.google_trackConversion) {
      window.dataLayer.push({ event });
    } else {
      // async tags -__-
      this.pendingEvents.push(event);
      if (!this.googleRemarketingInterval) {
        this.googleRemarketingInterval = setInterval(() => {
          if (window.google_trackConversion) {
            clearInterval(this.googleRemarketingInterval);
            this.googleRemarketingInterval = null;
            _.each(this.pendingEvents, pendingEvent => window.dataLayer.push({ event: pendingEvent }));
            this.pendingEvents = [];
          }
        }, 100);
      }
    }
  }
}

export default new GoogleRemarketing();


// WEBPACK FOOTER //
// ./source/client/analytics/google-remarketing.js